import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { BannerProps } from './types';

const ScheduledMaintenanceOutageBanner = () =>
  import(/* webpackChunkName: "4-feat-scheduled-maintenance-outage-banner" */ './ScheduledMaintenanceOutageBanner');

const LoadableScheduledMaintenanceOutageBanner: ComponentType<BannerProps> = lazyLoadOnRender({
  loader: ScheduledMaintenanceOutageBanner,
});
export default LoadableScheduledMaintenanceOutageBanner;
